// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"style__playerWrapper__yPZr0","instructions":"style__instructions__E+Wgp","description":"style__description__T3wh-"};